import { c as classNames } from '../../index-b0444989.js';
import React__default from 'react';
import { u as useId } from '../../useId-c06b4672.js';
import { P as Popover } from '../../index-930383e2.js';
import { Typography } from './Typography.js';
import '../../tslib.es6-ff7ae7b8.js';
import 'react-spring';
import 'react/jsx-runtime';
import 'react-dom';
import '../../useOrchard-4d335da4.js';
import '../../countries-0aa398a1.js';
import './IconButton.js';
import '../../skeleton.module-58f87ef6.js';
import './TextLink.js';
import '../../ResizeObserver-67118f52.js';
import '../../CircleAlertIcon-260aea89.js';
import '../../CloseIcon-ee1d8a9a.js';
import '../../InfoIcon-a2368fdb.js';
import '../../ThemeProvider-22ee39e3.js';

var styles = {"tooltip":"Tooltip_tooltip_dab5062c","default":"Tooltip_default_dab5062c","body":"Tooltip_body_dab5062c","content":"Tooltip_content_dab5062c","strong":"Tooltip_strong_dab5062c","black":"Tooltip_black_dab5062c","title":"Tooltip_title_dab5062c"};

var TooltipContent = function (_a) {
    var children = _a.children, title = _a.title;
    return (React__default.createElement("div", { className: styles.content },
        title && (React__default.createElement(Typography, { as: "div", variant: "body_md", className: styles.title }, title)),
        children && (React__default.createElement(Typography, { as: "div", variant: "body_sm", className: styles.body }, children))));
};
var Tooltip = function (props) {
    var _a;
    var _b = React__default.useState(false), isHover = _b[0], setHover = _b[1];
    var isOpen = props.isOpen, children = props.children, _c = props.placement, placement = _c === void 0 ? "right" : _c, className = props.className, dataTestId = props["data-testid"], content = props.content, _d = props.variant, variant = _d === void 0 ? "default" : _d;
    var tooltipId = useId();
    var handleMouseEnter = function () {
        setHover(true);
    };
    var handleMouseLeave = function () {
        setHover(false);
    };
    return (React__default.createElement(Popover, { isOpen: isOpen || isHover, onClose: function () { return undefined; }, placement: placement, showArrow: true, disableOverlay: true, disableScale: true, variant: variant, removePadding: true, content: React__default.createElement("div", { id: tooltipId, "data-testid": dataTestId, className: classNames(styles.tooltip, (_a = {}, _a[styles[variant]] = variant, _a), className), onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, content) }, React__default.cloneElement(children, { "aria-describedby": tooltipId })));
};

export { Tooltip, TooltipContent };
